export default __webpack_public_path__ + "static/media/icn-clock.6d410633.svg";